import { Component, OnInit ,ViewChild, TemplateRef} from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from '../_services/authentication.service';
import {CsrService} from "../_services/csr.service";
import { FormBuilder, FormControl,FormGroup,  Validators,  } from "@angular/forms";
import { CsrUser } from '../_models/csr.model';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-csrlogin',
  templateUrl: './csrlogin.component.html',
  styleUrls: ['./csrlogin.component.css']
})



export class CsrLoginComponent implements OnInit {
  public loginForm: any; 
  loading = false;
  submitted = false;
  public csrUser: CsrUser ={companyID:'',subcompanyID:'',  csrUserID:'',csrPassword:'',insuredEmailID:'',
  nameID:'',name:'',noofAttempts:0,onlineAccessCode:'',insuredUpdatedEmailID:'',
  edeliveryStatus: '', remindLaterDate: new Date(), userID:''

};
  loginSuccess: boolean = true;
  CompanyName: string;
  @ViewChild("csrEdeliveryModal") edeliveryModalContent: TemplateRef<any>;

constructor(private formBuilder: FormBuilder, private router: Router,private csrService : CsrService,private actrouter : ActivatedRoute, private modalService: NgbModal) {}

ngOnInit() {
this.loginForm = new FormGroup({
LoginEmail: new FormControl("", [Validators.required]),
loginPassword: new FormControl("", [Validators.required]),
insUserEmail: new FormControl("", [Validators.required]),
});
this.csrUser.companyID = environment.companyCode;
this.csrUser.subcompanyID = environment.companyCode;
  if (environment.companyCode == "MPI") {
    this.CompanyName = "MPIUA"
  }
  else {
    this.CompanyName = "RIJRA"
  }

}

onSubmit() {
  this.submitted = true;
   
    if (this.loginForm.invalid) {
      console.log(this.loginForm.invalid);
      return;
  }
  this.csrService.Login(this.csrUser)
  .subscribe(
    response => {
      if(response){
        if(response==true){
         
        }
        else if(response>=5){
          //this.accountLocked=true;
        }
        else{
          this.submitted=true;
        this.loginSuccess=true;
       // this.router.navigate(['/dashboard']);
//////
        let noofdays =0;
        if(response.remindLaterDate !='0001-01-01T00:00:00')
        {
          let currentDate = new Date();
          let remindDate = new Date(response.remindLaterDate); 
          let rDate= Date.UTC(remindDate.getFullYear(),remindDate.getMonth(), remindDate.getDate());
          let cDate = Date.UTC(currentDate.getFullYear(),currentDate.getMonth(), currentDate.getDate());
          let diff = cDate - rDate;
          var floorv= Math.floor(diff/(1000*3600*24));
          console.log('floorv:'+floorv);
          noofdays = floorv;
        }   
        if ((response.edeliveryStatus == 'N' || response.edeliveryStatus == null)  &&
          ( response.remindLaterDate==='0001-01-01T00:00:00' || noofdays >=30)) {
              // open the modal popup
              this.openEdeliveryModal(this.edeliveryModalContent);
            }
        else{
              this.router.navigate(['/dashboard']);
        }
           
         

/////




        }
      }
         else{
          this.loginSuccess=false;
         }       
    },
    error => {
      console.log(error);
      this.loginSuccess=false;
    });
}
openEdeliveryModal(content: any) {
  debugger;
  this.modalService.open(content);
}

UpdateEdelivery(status: string) {

  if (status === 'yes' || status == 'remindlater')
    {
    if (status == 'yes') {
      this.csrUser.edeliveryStatus = 'Y';
    }
    else if (status == 'remindlater') {
      this.csrUser.edeliveryStatus = 'remindlater';
      this.csrUser.remindLaterDate = new Date();
      this.csrUser.userID = this.csrUser.insuredEmailID;
    }
   
   //api call
   this.csrService.UpdateEdeliveryStatus(this.csrUser)
    .subscribe(
      response => {
        if (response) {

          this.router.navigate(['/dashboard']);
          //alert('You have successfully enrolled!');
         // this.user.edeliveryStatus = 'N';
        }
        else {

          console.log("UpdateEdeliveryStatus response:"+ response);
        }
      },
      error => {
        console.log(error);

      });
    
  }
}

}
